export default __webpack_public_path__ + "static/3-9af3dac1a06f32509caa80335fef4fc0.png";